import { MutateOptions, useMutation, useQueryClient } from 'react-query';

import { Hashtag } from '../../../types/Hashtag';
import { Topic } from '../../../types/Topic';
import Api from '../../api/api';

export type PostUpdateDTO = {
  categoryId?: string;
  subCategoryId?: string;
  editAllowed?: boolean;
  topic?: Topic[];
  description?: string;
  hashtag?: Hashtag[];
};

export const updatePost = async (postId: string, params: PostUpdateDTO) => {
  const [response, bodyOrError] = await Api.patch(`posts/${postId}`, params);

  if (!response.ok) {
    throw bodyOrError;
  }

  return response;
};

export const useUpdatePost = (
  options?: MutateOptions<Awaited<ReturnType<typeof updatePost>>, unknown, { postId: string; params: PostUpdateDTO }, unknown>,
) => {
  const queryClient = useQueryClient();

  return useMutation(
    'updatePost',
    (data: { postId: string; params: PostUpdateDTO }) => {
      return updatePost(data.postId, data.params);
    },
    {
      onSuccess: (data, vars, ctx) => {
        queryClient.invalidateQueries(['getPosts']);
        queryClient.invalidateQueries(['getPostById', vars.postId]);
        options?.onSuccess && options.onSuccess(data, vars, ctx);
      },
    },
  );
};
